import { InformerProps } from '@/shared/ui';

import { erzStatusName } from '@/modules/erz/pages/WeaponRegistered/uk.l10n';

import { formatDate } from '@/helpers/dates';

import { WeaponMode, StatusDecorator, Weapon_v2, WeaponStatuses } from '@/api/types';

import { getDayWord } from '../../helpers/getDayWord';
import { Row } from '../RowRenderer';

export const getRow1 = (data: Weapon_v2): Row[] => {
  if (data.weaponType === 'firearm_part') {
    return [
      {
        label: 'Тип зброї',
        value: data.typeName,
        dataTestId: 'weapon-permit-card-type',
      },
      {
        label: 'Cерія та номер',
        value: data?.serialNumber,
        dataTestId: 'weapon-permit-card-seria',
      },
      {
        label: 'Номер дозволу',
        value: data.permitNumber,
        dataTestId: 'weapon-permit-card-number',
      },
    ];
  }
  return [
    {
      label: 'Тип зброї',
      value: data.typeName,
      dataTestId: 'weapon-permit-card-type',
    },
    {
      label: 'Модель',
      value: data?.model,
      dataTestId: 'weapon-permit-card-model',
    },
    {
      label: 'Cерія та номер',
      value: data?.serialNumber,
      dataTestId: 'weapon-permit-card-seria',
    },
  ];
};

export const getRow2 = (data: Weapon_v2): Row[] => {
  if (data.weaponType === 'firearm_part') {
    return [
      {
        label: 'Термін дії',
        value: formatDate(data?.permitExpiredAt),
        dataTestId: 'weapon-permit-card-term',
      },
    ];
  }
  return [
    {
      label: 'Номер дозволу',
      value: data.permitNumber,
      dataTestId: 'weapon-permit-card-number',
    },
    {
      label: 'Термін дії',
      value: formatDate(data?.permitExpiredAt),
      dataTestId: 'weapon-permit-card-term',
    },
  ];
};

export const expirationPermitInformer = (daysRemaining: Nullable<number>): InformerProps | null => {
  if (!daysRemaining) return null;

  const dayWord = getDayWord(daysRemaining);
  return {
    header: {
      text: `Термін дії дозволу на зберігання та носіння закінчується через ${daysRemaining} ${dayWord}`,
      color: 'red',
    },
    icon: { name: 'attention', color: 'red' },
    bgColor: 'white',
    borderColor: 'none',
  };
};

export const purchasePermitInformer = (daysRemaining: Nullable<number>): InformerProps | null => {
  if (!daysRemaining) return null;

  const lastDigit = +daysRemaining % 10;
  const dayWord = lastDigit === 1 ? 'дня' : 'днів';

  return {
    header: {
      text: `Ви маєте отримати дозвіл на зберігання та носіння протягом  ${daysRemaining} ${dayWord}`,
      color: 'red',
    },
    icon: { name: 'attention', color: 'red' },
    bgColor: 'white',
    borderColor: 'none',
  };
};

export const statuses: Record<WeaponStatuses, StatusDecorator> = {
  PERMITTED: {
    name: erzStatusName[WeaponMode.PERMITTED],
    color: 's-grass',
    text_color: 'white',
    icon: null,
    message_color: null,
    message_icon: null,
  },
  COMMISSION_SALE: {
    name: erzStatusName[WeaponMode.COMMISSION_SALE],
    color: 's-steel',
    text_color: 'white',
    icon: null,
    message_color: null,
    message_icon: null,
  },
  REPAIR: {
    name: erzStatusName[WeaponMode.REPAIR],
    color: 's-carrot',
    text_color: 'white',
    icon: null,
    message_color: null,
    message_icon: null,
  },
  HAS_TIME_OUT: {
    name: 'Протермінований дозвіл на зберігання та носіння',
    color: 's-terracotta',
    text_color: 'white',
    icon: null,
    message_color: null,
    message_icon: null,
  },
  HAS_NO_STORAGE_CARRYING: {
    name: 'Не отримано дозвіл на зберігання та носіння',
    color: 's-terracotta',
    text_color: 'white',
    icon: null,
    message_color: null,
    message_icon: null,
  },
  MIN_AGE_18: {
    name: 'Для володіння зброєю вам має бути 18 років',
    color: 's-terracotta',
    text_color: 'white',
    icon: 'attention',
    message_color: null,
    message_icon: null,
  },
  MIN_AGE_21: {
    name: '	Для володіння вогнепальною зброєю вам має бути 21 рік',
    color: 's-terracotta',
    text_color: 'white',
    icon: 'attention',
    message_color: null,
    message_icon: null,
  },
  MIN_AGE_25: {
    name: 'Для володіння нарізною зброєю вам має бути 25 років',
    color: 's-terracotta',
    text_color: 'white',
    icon: 'attention',
    message_color: null,
    message_icon: null,
  },
};
